// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2xxMw","card":"styles_card__1VWIy","icon":"styles_icon__17rHP","text":"styles_text__1s4e0"};